import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { CLEMENTINE_ROLES, roleDescription } from '../clementineRoles';

export default function IntakeForm({ startupError = '' }) {
  const [profile, setProfile] = useState({ firstName:'',lastName:'',email:'',phone:'',role:'' });
  const [error,setError] = useState(startupError);
  const [submitting,setSubmitting] = useState(false);
  const [requested,setRequested] = useState(false);
  const [config,setConfig] = useState({});
  useEffect(()=>{axios.get('/api/config').then(({data})=>setConfig(data)).catch(()=>{});},[]);
  const update = event => setProfile({ ...profile,[event.target.name]:event.target.value });
  async function submit(event) {
    event.preventDefault();
    setError('');setSubmitting(true);
    try {
      await axios.post('/api/access/request',config.enrollmentMode==='hr'?{email:profile.email,role:profile.role,phone:profile.phone}:profile,{ headers:{'x-training-request':'1'},withCredentials:true });
      setRequested(true);
    } catch(e) { setError(e.response?.data?.error || 'We could not request your link. Check your details and try again.'); }
    finally { setSubmitting(false); }
  }
  return <div className="page-container registration-page">
    <div className="step-badge">Your training starts here</div>
    <h1 className="page-title">Protecting privacy, together.</h1>
    <p className="page-subtitle">Clementine ABA HIPAA training · Five shared lessons, one lesson for your role, and a short knowledge check.</p>
    <div className="journey-strip" aria-label="Training steps"><span>1. Your details</span><span>2. Videos</span><span>3. Quiz</span><span>4. Sign</span><span>5. Certificate</span></div>
    {config.localPreview&&<p className="preview-notice">Local preview: emails are captured in the <a href="/__preview" target="_blank" rel="noreferrer">preview inbox</a>. No email is sent.</p>}
    <div className="card">
      {requested ? <div role="status" aria-live="polite">
        <h2>Check your email</h2>
        {config.enrollmentMode==='hr' ? <>
          <p className="spaced">If your email is on file with Clementine, your training link is on its way. It usually arrives within a minute or two.</p>
          <p className="spaced">Already asked for a link in the last 15 minutes? Use the newest email you have. A new one won’t be sent yet.</p>
          <p className="spaced">Check your spam or junk folder too. Still nothing after a few minutes? Email clementine-it@odysseysolutions.co and we’ll help.</p>
        </> : <>
          <p className="spaced">If your address is eligible, you’ll receive a secure link to start or resume training. The link expires after 30 minutes.</p>
          <p className="spaced">Check your spam folder too. If you still cannot find it, contact your training administrator.</p>
        </>}
        <button className="btn btn-outline" onClick={()=>setRequested(false)}>Review my details</button>
      </div> : <form onSubmit={submit}>
        <h2>Your employee details</h2>
        <p className="form-hint spaced">All fields are required. Your name will appear on your certificate.</p>
        {error && <p className="error-banner" role="alert">{error}</p>}
        <div className="form-grid">
          {[['firstName','First name','given-name','text'],['lastName','Last name','family-name','text'],['email','Email address','email','email'],['phone','Phone number','tel','tel']].map(([name,label,autoComplete,type])=><div className="form-group" key={name}>
            <label className="form-label" htmlFor={name}>{label} <span aria-hidden="true">*</span></label>
            <input className="form-input" id={name} name={name} type={type} autoComplete={autoComplete} required maxLength={name==='email'?254:name==='phone'?35:80} value={profile[name]} onChange={update} disabled={submitting} aria-describedby={name==='phone'?'phone-hint':undefined}/>
            {name==='phone' && <span id="phone-hint" className="form-hint">Include your country code outside the US, for example +44.</span>}
          </div>)}
          <div className="form-group form-group--full">
            <label className="form-label" htmlFor="role">Your role <span aria-hidden="true">*</span></label>
            <select className="form-select" id="role" name="role" value={profile.role} onChange={update} required disabled={submitting}>
              <option value="">Choose your training role</option>
              {CLEMENTINE_ROLES.map(role=><option key={role.value} value={role.value}>{role.value}</option>)}
            </select>
          </div>
        </div>
        {profile.role && <div className="role-quick-info" aria-live="polite"><strong>Your role-specific lesson</strong><p>{roleDescription(profile.role)}</p></div>}
        <button className="btn btn-primary btn--full spaced" disabled={submitting}>{submitting?'Requesting your link…':'Email my training link →'}</button>
        <p className="form-hint">{config.enrollmentMode==='hr'
          ? 'Already started? Sign in to OdyHR at clementine.odyhr.app and open My training to pick up where you left off.'
          : 'Already started? Enter your details with the same email and role to resume your saved progress.'}</p>
      </form>}
    </div>
    <p className="registration-footer">About 16 minutes of video · Pass with 80% · Retake as needed</p>
  </div>;
}
